import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { connect } from 'react-redux';

const BetslipTypes = MojitoServices.Betslip.types;
const {
    actions: betslipActions,
    selectors: { selectBetslipSettings },
} = MojitoServices.Betslip;
const { FlexPane, ToggleButton } = MojitoPresentation.Components;

class BettingSettings extends MojitoCore.Presentation.UIViewImplementation {
    constructor(...args) {
        super(...args);

        this.onAllToggled = this.onAllToggled.bind(this);
        this.onHigherToggled = this.onHigherToggled.bind(this);
        this.onLowerToggled = this.onLowerToggled.bind(this);
        this.onUseQuickBetslipToggled = this.onUseQuickBetslipToggled.bind(this);
    }

    getQuickBetslipUsedState() {
        return this.config.enableQuickBetslipConfiguration && this.props.isQuickBetslipEnabled;
    }

    getChangePayload(settings) {
        return { priceChangeAcceptance: settings };
    }

    onAllToggled() {
        const acceptAll = !this.getAutoAcceptValues().all;
        this.props.dispatch(
            betslipActions.betslipSettingsChange(
                this.getChangePayload({
                    [BetslipTypes.PRICE_CHANGE_TYPE.HIGHER]: acceptAll,
                    [BetslipTypes.PRICE_CHANGE_TYPE.LOWER]: acceptAll,
                })
            )
        );
        this.emitAnalytics('betslipChangeAcceptAllPrices', acceptAll ? 'Yes' : 'No');
    }

    onHigherToggled() {
        const { dispatch, priceChangeAcceptance } = this.props;
        const { HIGHER } = BetslipTypes.PRICE_CHANGE_TYPE;
        const acceptHigher = !priceChangeAcceptance[HIGHER];
        dispatch(
            betslipActions.betslipSettingsChange(this.getChangePayload({ [HIGHER]: acceptHigher }))
        );
        this.emitAnalytics('betslipChangeAcceptHigherPrices', acceptHigher ? 'Yes' : 'No');
    }

    onLowerToggled() {
        const { dispatch, priceChangeAcceptance } = this.props;
        const { LOWER } = BetslipTypes.PRICE_CHANGE_TYPE;
        const acceptLower = !priceChangeAcceptance[LOWER];
        dispatch(
            betslipActions.betslipSettingsChange(this.getChangePayload({ [LOWER]: acceptLower }))
        );
        this.emitAnalytics('betslipChangeAcceptLowerPrices', acceptLower ? 'Yes' : 'No');
    }

    onUseQuickBetslipToggled() {
        const { dispatch, isQuickBetslipEnabled } = this.props;
        dispatch(
            betslipActions.betslipSettingsChange({ quickBetslipEnabled: !isQuickBetslipEnabled })
        );
    }

    getAutoAcceptValues() {
        const { higher, lower } = this.props.priceChangeAcceptance;
        const all = higher && lower;
        return { all, higher, lower };
    }

    render() {
        const autoAccept = this.getAutoAcceptValues();
        const { automaticPriceChangeAcceptance, enableQuickBetslipConfiguration } = this.config;
        const { configurable } = automaticPriceChangeAcceptance;

        return (
            <FlexPane config={this.config.container} class="ta-BettingSettingsPopup">
                {configurable.all && (
                    <ToggleButton
                        config={this.config.toggleButton}
                        value={autoAccept.all}
                        onToggle={this.onAllToggled}
                        class="ta-BettingSettings-toggle_all"
                        label={this.resolveString(
                            '$BETTING_SETTINGS.AUTOMATIC_PRICE_CHANGE_ACCEPTANCE.ALL'
                        )}
                    />
                )}
                {configurable.higher && (
                    <ToggleButton
                        config={this.config.toggleButton}
                        value={autoAccept.higher}
                        disabled={autoAccept.all}
                        onToggle={this.onHigherToggled}
                        class="ta-BettingSettings-toggle_higher"
                        label={this.resolveString(
                            '$BETTING_SETTINGS.AUTOMATIC_PRICE_CHANGE_ACCEPTANCE.HIGHER'
                        )}
                    />
                )}
                {configurable.lower && (
                    <ToggleButton
                        config={this.config.toggleButton}
                        value={autoAccept.lower}
                        disabled={autoAccept.all}
                        onToggle={this.onLowerToggled}
                        class="ta-BettingSettings-toggle_lower"
                        label={this.resolveString(
                            '$BETTING_SETTINGS.AUTOMATIC_PRICE_CHANGE_ACCEPTANCE.LOWER'
                        )}
                    />
                )}
                {enableQuickBetslipConfiguration && (
                    <ToggleButton
                        config={this.config.toggleButton}
                        value={this.props.isQuickBetslipEnabled}
                        onToggle={this.onUseQuickBetslipToggled}
                        class="ta-BettingSettings-toggle-use-quick-betslip"
                        label={this.resolveString('$BETTING_SETTINGS.USE_QUICK_BETSLIP')}
                    />
                )}
            </FlexPane>
        );
    }
}

BettingSettings.getStyle = config => config.style;

const mapStateToProps = state => {
    const { quickBetslipEnabled, priceChangeAcceptance } = selectBetslipSettings(state);
    return { priceChangeAcceptance, isQuickBetslipEnabled: quickBetslipEnabled };
};

export default connect(mapStateToProps)(BettingSettings);
